module.exports = __webpack_public_path__ + "static/media/new_pack_dog_285x350_FR.bc1ba698.png";